module.exports = __webpack_public_path__ + "img/time2lucky-introduction.a7525385.png";